// Recursively converts an Error (including nested Braintree `details` /
// `originalError` / `error` chains) into a plain serialisable object. Captures
// the non-enumerable standard fields that JSON.stringify would otherwise drop
// (name/code/type/message/httpStatus) and guards against circular references.
export function serializeError(err, seen) {
  seen = seen || new Set();
  if (err === null || typeof err !== 'object') return err;
  if (seen.has(err)) return '[Circular]';
  seen.add(err);

  if (Array.isArray(err)) {
    return err.map(item => serializeError(item, seen));
  }

  const result = {};
  ['name', 'code', 'type', 'message', 'httpStatus'].forEach(key => {
    if (err[key] !== undefined) result[key] = err[key];
  });
  Object.keys(err).forEach(key => {
    if (result[key] === undefined) {
      result[key] = serializeError(err[key], seen);
    }
  });
  return result;
}

// Returns the whole error tree as a JSON string, safe for logging.
export function stringifyError(err) {
  try {
    return JSON.stringify(serializeError(err));
  } catch (e) {
    return String(err);
  }
}
